import { forwardRef } from 'react';
import Text from '../Text';
import ErrorWrapper from './style/errorWrapper';
import LabelWrapper from './style/labelWrapper';
import TextareaWrapper from './style/textareaWrapper';

const Textarea = forwardRef((props, ref) => {
  const { label, error, className, ...rest } = props;

  const errorMessage = error ? (
    <Text size='SM' className='error-message'>
      {error}
    </Text>
  ) : null;

  if (label) {
    return (
      <LabelWrapper className={className}>
        <Text size='SM' className='label-text'>
          {label}
        </Text>
        <TextareaWrapper ref={ref} {...rest} />
        {errorMessage}
      </LabelWrapper>
    );
  }
  if (error) {
    return (
      <ErrorWrapper className={className}>
        <TextareaWrapper ref={ref} {...rest} />
        {errorMessage}
      </ErrorWrapper>
    );
  }

  return <TextareaWrapper className={className} ref={ref} {...rest} />;
});

Textarea.displayName = 'Textarea';
export default Textarea;
